import { NestedPropertyPipe } from './pipes/nested-property.pipe';
import { TimeAgoPipe } from '../core/pipes/time-ago.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [TimeAgoPipe, NestedPropertyPipe],
  imports: [CommonModule],
  exports: [TimeAgoPipe, NestedPropertyPipe],
})
export class CoreModule {}
